import { store } from '@/store/index';
import { ref } from 'vue';

import { dispatchPostInquiryEn } from '@/store/main/actionsMain';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useInquiryComposable = (): any => {
  const isValidForm = ref<boolean>(false);
  const isLoading = ref<boolean>(false);
  const firstName = ref<string>('');
  const lastName = ref<string>('');
  const middleName = ref<string>('');
  const phone = ref<string>('');
  const department = ref<string>('');
  const position = ref<string>('');
  const companyName = ref<string>('');
  const email = ref<string>('');
  const recaptchaToken = ref('');

  const submit = async (): Promise<void> => {
    isLoading.value = true;
    try {
      const data = {
        first_name: firstName.value,
        last_name: lastName.value,
        middle_name: middleName.value,
        email: email.value,
        phone: phone.value,
        department: department.value,
        position: position.value,
        company_name: companyName.value,
        g_recaptcha_response: recaptchaToken.value,
      };
      const payloadData = { payload: data };
      await dispatchPostInquiryEn(store, payloadData);
    } catch (e) {
      console.log(e);
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isValidForm,
    isLoading,
    firstName,
    lastName,
    middleName,
    phone,
    department,
    position,
    companyName,
    email,
    submit,
  };
};
